import React from 'react';
import classnames from 'classnames';
import { withTheme } from '@ifit/themes/withTheme';
import './index.scss';

export interface IProps {
  className?: string;
  themeClass?: string;
}

const CardSkeleton = ({ className, themeClass, ...rest }: IProps) => {
  return (
    <div
      className={classnames('mp-card-skeleton', themeClass, className)}
      data-testid="mp-card-skeleton"
      {...rest}
    />
  );
};

export default withTheme(CardSkeleton);
